import { render, staticRenderFns } from "./addLinkModal.vue?vue&type=template&id=626da2f4&scoped=true&"
import script from "./addLinkModal.ts?vue&type=script&lang=ts&"
export * from "./addLinkModal.ts?vue&type=script&lang=ts&"
import style0 from "./addLinkModal.vue?vue&type=style&index=0&id=626da2f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626da2f4",
  null
  
)

export default component.exports